import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Grid,
  Text,
} from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';
import { useEffect, useState } from 'react';
import { useAppDispatch } from 'app/store';
import { getImportRecordEffect } from 'app/store/Import/effects';

export const SongImportDetails = () => {
  const dispatch = useAppDispatch();

  const [record, setRecord] = useState<[key: string, value: string][]>([]);

  useEffect(() => {
    dispatch(getImportRecordEffect())
      .unwrap()
      .then((record) => setRecord(record));
  }, [dispatch]);

  return (
    <Accordion allowToggle w="full">
      <AccordionItem borderColor="borderBase">
        <AccordionButton py={4}>
          <Box as="span" flex="1" textAlign="left">
            Import Details
          </Box>
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel pb={4}>
          <Box borderTop="1px solid" borderColor="borderBase" mt={4}>
            {record
              .filter(([, value]) => !!value)
              .map(([key, value]) => (
                <Grid
                  key={key}
                  templateColumns="1fr 1fr"
                  gap={4}
                  borderBottom="1px solid"
                  borderColor="borderBase"
                  _hover={{
                    bg: transparentize('surface2', 0.36),
                  }}
                >
                  <Text color="textBase" fontWeight="bold" p={4}>
                    {key}
                  </Text>
                  <Text p={4}>{value}</Text>
                </Grid>
              ))}
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
